import { z } from "zod";

import { idSchema } from "~/lib/id";

export const createOrganizationSchema = z.object({
	name: z.string().min(3).max(24),
	logo: idSchema("image").nullable(),
});
